import { Directive, ElementRef, Input, Optional, Renderer2 } from "@angular/core";
import { MatButton, MatFormField, MatFormFieldControl, MatInput, MatSelect } from "@angular/material";
import { config } from "rxjs";
import { Permission } from "../models/BasicData/Permission";
import { Globals } from "../services/globals";

@Directive({
  selector: '[appPermission]'
})
export class RolePermissionsDirective {
 
  @Input('appPermission') perName: String;


  constructor(    private renderer: Renderer2,
  @Optional() private  btn:MatButton , @Optional() private  fd:MatFormField,private g :Globals,@Optional() private  ms:MatSelect,@Optional() private  ma:MatButton,@Optional() private matInput: MatInput,private el: ElementRef) { 



     if(g.perms)
     {

     
    if (this.matInput ) {
    // It's a Material Input
      this.g.perms.forEach(element => {
          console.log('here');
          console.log(this.matInput.id);
      if(this.matInput.id==element.elementId)
      {
        console.log(element.isReadOnly);

      this.matInput.disabled=element.isReadOnly;
      }
    });
      //this.matInput.='hidden'
  }
  

  
  else if(this.ms)
  {
    this.g.perms.forEach(element => {
      console.log('here');
  if(this.ms.id==element.elementId)
  {
    console.log(element.isReadOnly);

  this.ms.disabled=element.isReadOnly;
  }
});
  }
  else{
    
    this.g.perms.forEach(element => {
  if(this.el.nativeElement.id==element.elementId)
  {

    console.log('jereq');
  this.el.nativeElement.disabled=true;
  }
});
      
  }
     }
  }
  private applyPerm(perm:String) {
    this.g.perms.forEach(element => {
        if(element.elementId==perm)
        {
           return element;
        }
    });
}
ngOnInit() {
   
    if(this.perName=="dis")
    {
      console.log('Got the value : ', this.perName);
   //   this.el.nativeElement.disabled=true;
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');

  // this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }
 
}


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/